import { Link } from '../util/router';
import wordmark from '../assets/images/wordmark.png';
import FeedFilterToolbar from './FeedFilterToolbar';
import { MobileMenuButton } from './shell/AppShell';

/** Sticky feed chrome (wordmark + toolbar + profile). */
const FeedHeader = ({
  homeFilterOptions,
  typeFilterOptions,
  locationTags,
  onToggleFilters,
  totalSelectedFilterCount,
}) => {
  return (
    <header className="sticky top-0 z-40 bg-[#f1f5f9]">
      <div className="w-full px-3 py-3 md:px-4 md:py-3.5">
        <div className="flex items-center justify-between md:hidden">
          <Link
            to="/feed"
            className="Showrunner shrink-0 text-secondary-red text-2xl font-medium uppercase leading-none"
          >
            <img src={wordmark} alt="Showrunner" className="w-[14.3rem]" />
          </Link>
          <div className="flex shrink-0 items-center">
            <MobileMenuButton />
          </div>
        </div>

        <div className="md:hidden">
          <FeedFilterToolbar
            homeFilterOptions={homeFilterOptions}
            typeFilterOptions={typeFilterOptions}
            locationTags={locationTags}
            onToggleFilters={onToggleFilters}
            totalSelectedFilterCount={totalSelectedFilterCount}
            showBottomRow={false}
          />
        </div>

        <div className="md:hidden">
          <FeedFilterToolbar
            homeFilterOptions={homeFilterOptions}
            typeFilterOptions={typeFilterOptions}
            locationTags={locationTags}
            onToggleFilters={onToggleFilters}
            totalSelectedFilterCount={totalSelectedFilterCount}
            showTopRow={false}
          />
        </div>

        <div className="hidden w-full items-center gap-6 md:flex">
          <Link
            to="/feed"
            className="Showrunner shrink-0 text-secondary-red text-2xl font-medium uppercase leading-none"
          >
            <img src={wordmark} alt="Showrunner" className="w-[15.6rem]" />
          </Link>
          <div className="min-w-0 flex-1">
            <FeedFilterToolbar
              homeFilterOptions={homeFilterOptions}
              typeFilterOptions={typeFilterOptions}
              locationTags={locationTags}
              onToggleFilters={onToggleFilters}
              totalSelectedFilterCount={totalSelectedFilterCount}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default FeedHeader;
